import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { bibShape, shelfItemShape, ugcCommentShape } from '@bibliocommons/bc-prop-types';
import TextUGCEditor from '../TextUGCEditor';

const CHARACTER_LIMIT = 4000;

export class CommentUGCEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    const { existingComment } = this.props;

    this.state = {
      comment: existingComment ? existingComment.get('comment', '') : ''
    };
  }

  handleTextChange(value) {
    this.setState({ comment: value });
  }

  handleSave(callback) {
    const { bib, existingComment, commentsActions } = this.props;
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const commentId = existingComment && existingComment.get('id');
    const comment = this.state.comment;
    const postSuccess = callback;

    if (commentId) {
      commentsActions.updateComment({
        comment,
        metadataId,
        commentId,
        postSuccess
      });
    } else {
      commentsActions.addComment({
        comment,
        metadataId,
        postSuccess
      });
    }
  }

  render() {
    const {
      bib,
      existingComment,
      commentsTransactions,
      shelfItem,
      shelfActions,
      shelfTransactions,
      handleClose,
      intl
    } = this.props;

    const commentId = existingComment && existingComment.get('id');
    const metadataId = bib.getIn(['briefInfo', 'metadataId']);
    const renderHeader = () => (
      <h2>{commentId ? <FormattedMessage id="my_comment" /> : <FormattedMessage id="add_comment" />}</h2>
    );
    const isSavingComment = commentId
      ? commentsTransactions.getIn([metadataId, commentId, 'isUpdating'], false)
      : commentsTransactions.getIn([metadataId, 'isAdding'], false);
    const placeholder = intl.formatMessage({ id: 'comment_placeholder' });
    const textAreaLabel = <FormattedMessage id="comment" />;

    return (
      <TextUGCEditor
        bib={bib}
        characterLimit={CHARACTER_LIMIT}
        className="cp-comment-ugc-editor"
        errorKey="comment"
        renderHeader={renderHeader}
        handleClose={handleClose}
        handleSave={this.handleSave}
        handleTextChange={this.handleTextChange}
        placeholder={placeholder}
        isSaving={isSavingComment}
        showPrivacyAlert
        shelfItem={shelfItem}
        shelfTransactions={shelfTransactions}
        shelfActions={shelfActions}
        textAreaLabel={textAreaLabel}
        text={this.state.comment}
      />
    );
  }
}

const injectIntlPropTypes = {};

CommentUGCEditor.propTypes = {
  bib: bibShape.isRequired,
  existingComment: ugcCommentShape,
  shelfItem: shelfItemShape,
  handleClose: PropTypes.func.isRequired,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ...injectIntlPropTypes
};

export default injectIntl(CommentUGCEditor);
